
import ForgotPasswordPage from '@/screens/ForgotPasswordPage.vue';
import ResetPasswordPage from '@/screens/ResetPasswordPage.vue';
import SignupPage from '@/screens/SignupPage.vue';
import BusinessApplicationsPage from '@/screens/transactions/BusinessApplicationsPage.vue';
import RPTaxPage from '@/screens/transactions/RPTaxPage.vue';
import WashPage from '@/screens/transactions/WashPage.vue';
import { hasRoles, isAuthenticated } from '@/utils/auth';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = () => import('@/screens/DashboardPage.vue');
const NotFound = () => import('@/screens/NotFound.vue');
const ForbiddenPage = () => import('@/screens/ForbiddenPage.vue');
const LoginPage = () => import('@/screens/LoginPage.vue');
const LandingPage = () => import('@/screens/LandingPage.vue');
const routes = [
    {
        path: '/',
        name: 'home',
        component: LandingPage,
        meta: { requiresAuth: false }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: HomePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['user', 'san', 'bplo', 'mpdc', 'treasury', 'obo', 'admin', 'it'] }
    },

    {
        path: '/transactions/apps',
        name: 'transactions-apps',
        component: BusinessApplicationsPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['user', 'san', 'bplo', 'mpdc', 'treasury', 'obo', 'admin', 'it'] }
    },
 {
        path: '/transactions/wash',
        name: 'transactions-wash',
        component: WashPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['user', 'san', 'bplo', 'mpdc', 'treasury', 'obo', 'admin', 'it'] }
    },
 {
        path: '/transactions/rpt',
        name: 'transactions-rpt',
        component: RPTaxPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['user', 'san', 'bplo', 'mpdc', 'treasury', 'obo', 'admin', 'it'] }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
    {
        path: '/signup',
        name: 'signup',
        component: SignupPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
     {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPasswordPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
       {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPasswordPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: ForbiddenPage,
    },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'LGU Palompon'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'dashboard' })
    }

    if ((to.path === '/login' || to.path === '/signup') && isAuthed)
        return next({ name: 'dashboard' });

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const hasAccess = hasRoles(to.meta.roles); // Example function to get user roles
        // Check if any of the user's roles match the allowed roles

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})



export default router;
